var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
/**
 * @reactapi
 * @module components
 */ /** */
import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';
import { servicesPlugin } from '@uirouter/core';
import { UIRouterReact } from '../index';
export var 
/** @internalapi */
UIRouterProvider = (_a = React.createContext(undefined), _a.Provider), 
/**
 * <UIRouterConsumer> component lets you access the UIRouter instance
 * anywhere in the component tree, by simply wrapping your component and
 * using the function-as-child pattern to pass the instance via props.
 *
 * #### Example:
 * ```jsx
 * <UIRouterConsumer>
 *  {router => <MyComponent router={router} />}
 * </UIRouterConsumer>
 * ```
 */
UIRouterConsumer = _a.Consumer;
/** @hidden */
export var InstanceOrPluginsMissingError = new Error("Router instance or plugins missing.\n You must either provide a location plugin via the plugins prop:\n \n <UIRouter plugins={[pushStateLocationPlugin]} states={[\u00B7\u00B7\u00B7]}>\n   <UIView />\n </UIRouter>\n \n or initialize the router yourself and pass the instance via props:\n \n const router = new UIRouterReact();\n router.plugin(pushStateLocationPlugin);\n \u00B7\u00B7\u00B7\n <UIRouter router={router}>\n   <UIView />\n </UIRouter>\n ");
/** @hidden */
export var UIRouterInstanceUndefinedError = new Error("UIRouter instance is undefined. Did you forget to include the <UIRouter> as root component?");
var UIRouter = /** @class */ (function (_super) {
    __extends(UIRouter, _super);
    function UIRouter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UIRouter.prototype.componentDidMount = function () {
        var _this = this;
        if (!this.router) {
            // check if a router instance is provided
            if (this.props.router) {
                this.router = this.props.router;
            }
            else if (this.props.plugins) {
                this.router = new UIRouterReact();
                this.router.plugin(servicesPlugin);
                this.props.plugins.forEach(function (plugin) { return _this.router.plugin(plugin); });
                if (this.props.config)
                    this.props.config(this.router);
                (this.props.states || []).forEach(function (state) { return _this.router.stateRegistry.register(state); });
            }
            else {
                throw InstanceOrPluginsMissingError;
            }
            this.router.start();
            this.forceUpdate();
        }
    };
    UIRouter.prototype.render = function () {
        return this.router ? React.createElement(UIRouterProvider, { value: this.router }, this.props.children) : null;
    };
    UIRouter.propTypes = {
        plugins: PropTypes.arrayOf(PropTypes.func),
        states: PropTypes.arrayOf(PropTypes.object),
        config: PropTypes.func,
        children: PropTypes.element.isRequired,
        router: PropTypes.object,
    };
    return UIRouter;
}(Component));
export { UIRouter };
//# sourceMappingURL=UIRouter.js.map